export default __webpack_public_path__ + "static/media/x-circle.c90faf14.svg";